import { render, staticRenderFns } from "./CategoriesDrawer.vue?vue&type=template&id=89d0a03a&scoped=true&"
import script from "./CategoriesDrawer.vue?vue&type=script&lang=js&"
export * from "./CategoriesDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesDrawer.vue?vue&type=style&index=0&id=89d0a03a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d0a03a",
  null
  
)

export default component.exports